module.exports = __webpack_public_path__ + "static/media/mp.f077d4cd.svg";